import { qAActionTypes } from './Constants';

const initialState = {
	overview: {
		total_count: 0,
		results: [],
		applied_filters: [],
	},
	list: [],
	loading: true,
	result_sections: [],
	search_terms: '',
	appliedFilters: {},
	noResults: false,
	isChangeFilters: false,
	loadingMyQuestions: true,
	loadingMyAnswers: true,
	myQuestionsData: {
		total_count: 0,
		results: [],
	},
	myAnswersData: {
		total_count: 0,
		results: [],
	},
	ranks: [],
	questionDetailsLoading: true,
	questionDetails: {},
	loadingRelatedQuestions: true,
	relatedQuestions: {
		total_count: 0,
		results: [],
	},
	isQuestionDeleted: false,
};

export default function qaReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};
	const { offset } = data || {};

	switch (type) {
		case qAActionTypes.GET_QA_OVERVIEW:
			return {
				...state,
				loading: !offset,
			};
		case qAActionTypes.GET_QA_OVERVIEW_SUCCESS:
			return {
				...state,
				loading: false,
				overview: data,
			};
		case qAActionTypes.GET_QA_OVERVIEW_ERROR:
		case qAActionTypes.GET_MY_QUESTIONS_ERROR:
		case qAActionTypes.GET_MY_ANSWERS_ERROR:
		case qAActionTypes.GET_HIW_RANKS_ERROR:
			return {
				...state,
				loading: false,
			};
		case qAActionTypes.CHANGE_FILTERS:
		case qAActionTypes.GET_HIW_RANKS_SUCCESS:
			return {
				...state,
				...data,
			};
		case qAActionTypes.GET_MY_QUESTIONS:
			return {
				...state,
				loadingMyQuestions: !data,
			};
		case qAActionTypes.GET_MY_QUESTIONS_SUCCESS:
			return {
				...state,
				loadingMyQuestions: false,
				myQuestionsData: data,
			};
		case qAActionTypes.GET_MY_ANSWERS:
			return {
				...state,
				loadingMyAnswers: !data,
			};
		case qAActionTypes.GET_MY_ANSWERS_SUCCESS:
			return {
				...state,
				loadingMyAnswers: !data,
				myAnswersData: data,
			};
		case qAActionTypes.GET_QUESTION_DETAILS:
			return {
				...state,
				questionDetailsLoading: !data.reload,
			};
		case qAActionTypes.GET_QUESTION_DETAILS_SUCCESS:
			if (
				data?.questionDetails &&
				!Object.prototype.hasOwnProperty.call(data.questionDetails, 'id')
			)
				return { ...state, isQuestionDeleted: true };
			return {
				...state,
				...data,
				questionDetailsLoading: false,
				isQuestionDeleted: false,
			};
		case qAActionTypes.GET_QUESTION_DETAILS_ERROR:
			return {
				...state,
				questionDetailsLoading: false,
			};
		case qAActionTypes.GET_RELATED_QUESTION:
			return {
				...state,
				loadingRelatedQuestions: !data.queries,
			};
		case qAActionTypes.GET_RELATED_QUESTION_SUCCESS:
			return {
				...state,
				...data,
				loadingRelatedQuestions: false,
			};
		case qAActionTypes.GET_RELATED_QUESTION_ERROR:
			return {
				...state,
				loadingRelatedQuestions: false,
			};
		case qAActionTypes.CLEAR_QUESTION_DETAILS:
			return {
				...state,
				questionDetails: {},
			};
		case qAActionTypes.SET_IS_DELETED_QUESTION:
			return {
				...state,
				isQuestionDeleted: false,
			};
		case qAActionTypes.CLEAN_QA_STATE:
			return initialState;

		case qAActionTypes.CLEAN_QUESTION_STATE:
			return {
				...state,
				myQuestionsData: {
					results: [],
				},
				relatedQuestions: {
					total_count: 0,
					results: [],
				},
				loadingRelatedQuestions: false,
				loadingMyQuestions: false,
			};

		default:
			return state;
	}
}
